export enum NodeModelTypeEnum {
  AirFilter = 'filter-node',
  AirTemperatureSensor = 'air-temperature-sensor-node',
  Booster = 'booster-node',
  Compressor = 'compressor-node',
  DesiccantAirDryer = 'air-dryer-desiccant-node',
  DewpointAndPressureSensor = 'combo-sensor-dewpoint-pressure-node',
  DewpointSensor = 'humidity-sensor-node',
  DryAirTank = 'dry-air-tank-node',
  Dummy = 'dummy-node',
  FlowAndPressureSensor = 'combo-sensor-flow-pressure-node',
  FlowSensor = 'flow-sensor-node',
  PressureSensor = 'pressure-sensor-node',
  ProductionFloor = 'production-floor-node',
  RefrigeratedAirDryer = 'air-dryer-refrigerated-node',
  Valve = 'valve-node',
  WaterPressureSensor = 'water-pressure-sensor-node',
  WetAirTank = 'wet-air-tank-node',
  InfluentFlowSensor = 'influent-flow-sensor-node',
  DissolvedOxygenSensor = 'dissolved-oxygen-sensor-node',
  PhSensor = 'ph-sensor-node',
  AmmoniaAmmoniumSensor = 'ammonia-ammonium-sensor-node',
  NitrateSensor = 'nitrate-sensor-node',
  NitriteSensor = 'nitrite-sensor-node',
  OxidationReductionPotentialSensor = 'oxidation-reduction-potential-sensor-node',
  Blower = 'blower-node',
  AerationBasin = 'aeration-basin-node',
}
